// lifecycle events
export const LIFE_CYCLE_EVENTS = {
  CART: {
    ADD_TO_CART: 'cart.add-to-cart',
  },
  PROMOTION_PRODUCTS: {
    CUSTOM_PROMO_CART: 'promotion-products.custom-promo-cart',
    DISABLE: 'promotion-products.disable',
    ITEMS_TO_ADD_TO_CART: 'promotion-products.items-to-add-to-cart',
  },
  QUICK_VIEW: {
    CLICK_FOOTER: 'quick-view.click-footer',
    CLICK_SELECTION: 'quick-view.click-section',
  },
};

// new relic custom events
export const NEW_RELIC_EVENTS = {
  ADD_ACCESSORY_PRODUCT: 'add-accessory-product',
  ADD_TO_CART_ERROR: 'add-to-cart-error',
  ADD_TO_CART_FAILURE: 'add-to-cart-failure',
  BUNDLE_ADD_TO_CART: 'bundle-added-to-cart',
  BUNDLE_PRODUCT_ADDED: 'bundle-product-added',
  BUNDLE_PRODUCT_CLICKED_ADDED: 'bundle-product-clicked-added',
  BUNDLE_PRODUCT_DRAGGED_ADDED: 'bundle-product-dragged-added',
  BUNDLE_PRODUCT_REMOVED: 'bundle-product-removed',
  BUNDLE_PRODUCT_CLICKED_REMOVED: 'bundle-product-clicked-removed',
  BUNDLE_PRODUCT_DRAGGED_REMOVED: 'bundle-product-dragged-removed',
  BUNDLE_QUICK_VIEW: 'bundle-quick-view',
  NON_VISUALIZED_PRODUCT_QUICK_VIEW: 'non-visualized-product-quick-view',
  BUNDLE_REMOVED_UNDO: 'bundle-removed-undo',
  BUNDLE_SUB_QUICK_VIEW: 'bundle-sub-quick-view',
  CLICK_ADD_CHOICE: 'click-add-choice',
  CLICK_START_BUNDLE_CHOICE: 'click-start-bundle-choice',
  CLICK_START_CHOICE: 'click-start-choice',
  CLICK_SELECT_CABINET_TEMPLATE: 'click-select-cabinet-template',
  CLICK_SELECT_CABINET_TEMPLATE_SUCCESS: 'click-select-cabinet-template-success',
  CLICK_SELECT_CABINET_TEMPLATE_FAILED: 'click-select-cabinet-template-failed',
  SAVE_POPULATED_DESIGNS_SUCCESS: 'save-populated-designs-success',
  SAVE_POPULATED_DESIGNS_ERROR: 'save-populated-designs-error',
  RECALCULATE_TOEKICKS_SUCCESS: 'recalculate-toekicks-success',
  RECALCULATE_TOEKICKS_FAILED: 'recalculate-toekicks-failed',
  CLICK_EXPLORE_COUNTERTOPS: 'click-explore-countertops',
  COMPATIBILITY_CHOICES: 'compatibility-choices',
  CREATED_DESIGN: 'created-design',
  DESIGN_LOADED: 'design-loaded',
  DESIGN_RESTART: 'design-restart',
  DROP_IN_STACK: 'drop-in-stack',
  FULFILLMENT_ERRORS: 'fulfillmentErrors',
  LOAD_SHARED_DESIGN: 'load-shared-design',
  LOAD_STACK_DIMENSIONS: 'load-stack-dimensions',
  LOAD_STACK_SUMMARY: 'load-stack-summary',
  LOAD_WALL_STORAGE_SUMMARY: 'load-wall-storage-summary',
  NON_VISUALIZED_PRODUCT_ADDED: 'non-visualized-product-added',
  NON_VISUALIZED_PRODUCT_REMOVED: 'non-visualized-product-removed',
  OPTIONS_CHOICES_HYDRATED: 'options-choices-hydrated',
  ORPHAN_DRAG: 'orphan-drag',
  PIP_PERSIST_ADD: 'pip-persist-add',
  PIP_TO_CALLOUT: 'pip-to-callout',
  PRICE_ADJUSTMENT_API_ERROR: 'price-adjustment-api-error',
  PRICE_ADJUSTMENT_MISSING_STORE_SKU: 'price-adjustment-missing-store-sku',
  PRINT_DESIGN: 'print-design',
  PRODUCT_ADDED: 'product-added',
  PRODUCT_REMOVED_UNDO: 'product-removed-undo',
  PRODUCT_REMOVED: 'product-removed',
  QUICK_VIEW: 'quick-view',
  SAVED_DESIGN: 'saved-design',
  SHARE_DESIGN: 'share-design',
  START_DRAG: 'start-drag',
  TOTAL_PRICE: 'total-price',
  UPDATE_NON_VISUALIZED_QTY: 'update-non-visualized-qty',
  UPDATE_SUMMARY_QTY: 'update-summary-quantity',
  UPDATED_STACK_DIMENSIONS: 'updated-stack-dimensions',
  ZOOM_CLOSE: 'zoom-close',
  ZOOM_IN: 'zoom-in',
  ZOOM_OPEN: 'zoom-open',
  ZOOM_OUT: 'zoom-out',
  SEARCH_COLLECTION_SKUS_FROM_NAVPARAM_ERROR: 'search-collection-skus-from-navparam',
  SEARCH_COLLECTION_SKUS: 'search-collection-skus',
  PRODUCTS_METADATA: 'products-metadata',
  ASYNC_COLLECTION_SERVICE_GCC: 'async-collection-service-gcc',
  NO_PRODUCTS_IN_CACHE: 'no-products-in-cache',
  NO_PRODUCTS_IN_MODAL: 'no-products-in-modal',
  NO_DIFFERENCE_TO_SSKU: 'no-difference-to-supersku',
  PRICE_PRODUCT_LOOKUP_FAIL: 'price-product-lookup-fail',
  ADD_TO_CART_Cabinet_VISUALIZER_FAIL: 'add-to-cart-cabinet-visualizer-fail',
  CABINET_IMAGE_FAILED_LOAD: 'cabinet-image-failed-load',
  CABINET_DRAG_START: 'cabinet-drag-start',
  PREVIEW_COLLECTION_SUCCESS: 'preview-collection-success',
  PREVIEW_COLLECTION_ERROR: 'preview-collection-error',
  CABINET_DRAG_FAILED_COLLISION: 'cabinet-drag-failed-collision',
  CABINET_DRAG_END: 'cabinet-drag-end',
  ADD_TO_CART_LIMIT_EXCEEDED: 'add_to_cart_limit_exceeded',
  SAVE_DESIGN_API_ERROR: 'save-design-api-error',
  CREATE_DESIGN_API_ERROR: 'create-design-api-error',
  LOAD_DESIGNS_API_ERROR: 'load-designs-api-error',
  COLLECTION_MATCHING_SUCCESS: 'collection-matching-success',
  COLLECTION_MATCHING_ERROR: 'collection-matching-error',
  APPLY_COLLECTION_MAPPING_SUCCESS: 'apply-collection-mapping-success',
  APPLY_COLLECTION_MAPPING_ERROR: 'apply-collection-mapping-error',
  HARD_BUNDLE: 'hard-bundle',
  SOFT_BUNDLE: 'soft-bundle',
  LOAD_PROJECT_NOT_FOUND: 'load-project-not-found',
  LOAD_PROJECT_ERROR: 'load-project-error',
  RELOAD_DESIGN_ERROR: 'reload-design-error',
  ADD_DESIGN_TO_PROJECT_ERROR: 'add-design-to-project-error',
  POPULATE_PRODUCT_PARENT_IDS_SUCCESS: 'populate-product-parent-ids-success',
  POPULATE_PRODUCT_PARENT_IDS_CACHE_FAILED: 'populate-product-parent-ids-cache-failed',
  POPULATE_PRODUCT_PARENT_IDS_ERROR: 'populate-product-parent-ids-error',
  APPLY_TEMPLATE_API_ERROR: 'apply-template-api-error',
  FAILED_ADD_CHOICE: 'failed-add-choice',
  CONTINUE_BUILDING: 'continue-building',
  IMAGE_FETCH_FAILED_S3: 'image-fetch-failed-s3',
  API_ENDPOINT_FAILURE: 'api-endpoint-failure',
};

export const ANALYTICS_EVENTS = {
  BUY_NOW: 'buy now',
  COPY_URL: 'copy url',
  RESTART_BUTTON: 'restart button',
  STACK_SUMMARY: 'stack summary',
  TRASH_CAN_BUTTON: 'trash can button',
  UNDO_BUTTON: 'undo button',
  VIEW_MY_PROMOS: 'view my promos',
  STEPPER_DECREMENT: 'stepper decrement',
  WEB_WEB_INTERACTION_LINK_CLICKS: 'web.webinteraction.linkClicks',
  CONFIGURATOR_CLICK: 'configurator click',
  WALLSTORAGE_SUMMARY: 'wall storage builder - summary view',
  WALLSTORAGE_BUY_NOW: 'view summary and buy',
};

export const CABINET_SELLER = {
  TYPE: 'Cabinet Seller',
  CALLOUT_BUTTON_TITLE: 'Try Our New Cabinet Visualizer',
  CALLOUT_REGION: 'Below Media Gallery',
};

export const CABINET_SHOP_YOUR_SPACE = {
  TYPE: 'Cabinet Shop Your Space',
  PAGE_LOADED: 'cabinet-shop-your-space-page-loaded',
};

export const INTERNAL_QUERY_PARAMS = {
  IN_STORE_APP: 'instoreapp',
  LDAP: 'ldap',
  STORE_NUMBER: 'storeNumber',
  SOURCE: 'source',
};

export const INTERNAL_QUERY_PARAMS_LIST = Object.values(INTERNAL_QUERY_PARAMS);

export const STACK_BUILDER = {
  TYPE: 'Stack Builder',
  PACKOUT: {
    OMS_ID: '325168962',
    CALLOUT_HEADER: 'Build Your PACKOUT Rack Solution',
    CALLOUT_BODY: 'Organize your PACKOUT items in your van, trailer, connex boxes, or shop',
    CALLOUT_BUTTON_TITLE: 'Start Building',
    CALLOUT_DECISION_MODAL: {
      HEADER_TITLE: 'Leave Builder',
      MESSAGE: 'You are about to leave the builder. Are you sure you want to continue?',
      CONFIRM_BUTTON_NAME: 'Continue',
      CANCEL_BUTTON_NAME: 'Close',
      REDIRECT_URL: '/p/build-your-rack-system/milwaukee-packout-rack/336143125'
    }
  }
};

export const VEHICLE_STORAGE = {
  TYPE: 'Rack Builder',
  PACKOUT: {
    OMS_ID: '336143125',
    CALLOUT_HEADER: 'Build Your Perfect PACKOUT System',
    CALLOUT_BODY: 'Mix & match 125+ products to design a storage system that meets your needs',
    CALLOUT_BUTTON_TITLE: 'Start Building',
    CALLOUT_DECISION_MODAL: {
      HEADER_TITLE: 'Leave Builder',
      MESSAGE: 'You are about to leave the builder. Are you sure you want to continue?',
      CONFIRM_BUTTON_NAME: 'Continue',
      CANCEL_BUTTON_NAME: 'Close',
      REDIRECT_URL: '/p/Milwaukee-Builder/325168962'
    }
  },
  PACKAGE_TYPES: {
    SINGLE_RACK: 'single-rack',
    MULTI_RACK: 'multi-rack'
  }
};

export const WALL_STORAGE = {
  TYPE: 'Wall Storage Builder',
  PACKOUT: {
    OMS_ID: '338909191',
    CALLOUT_HEADER: 'Build Your Wall Plate System',
    CALLOUT_BODY: 'Mix & Match 75+ products to design a storage system that meets your needs',
    CALLOUT_BUTTON_TITLE: 'Start Building',
    REDIRECT_URL: '/p/build-your-wall-storage/sample-wall/338909191',
    CALLOUT_DECISION_MODAL: {
      HEADER_TITLE: 'Leave Builder',
      MESSAGE: 'You are about to leave the builder. Are you sure you want to continue?',
      CONFIRM_BUTTON_NAME: 'Continue',
      CANCEL_BUTTON_NAME: 'Close'
    }
  }
};

export const CONFIGURATOR = {
  OPTIONS: {
    NON_VISUALIZED_OPTION: 'non-viz-option',
    DEFAULT_BUILDER_OPTION_INDEX: '1',
    DEFAULT_RACKS_OPTION_INDEX: '0',
    MULTI_RACK: 'Multi Rack Packages'
  },
  CHOICE: {
    ACCESSORY: 'Accessory'
  }
};

export const DRAG_AND_DROP = {
  TRASH_CAN: 'trash-can',
  DROPPABLE: 'droppable'
};

export const CABINET_VISUALIZER_DIGITAL_DATA = {
  CONFIGURATOR: {
    HOW_IT_WORKS: 'cabinet configurator - how it works',
    ADD_WALL: 'cabinet configurator - add wall',
    EDIT_WALL: 'cabinet configurator - edit wall',
    ADD_CABINET: 'cabinet configurator - add cabinet',
    DUPLICATE_CABINET: 'cabinet configurator - duplicate cabinet',
    CHOOSE_CABINET_COLLECTION: 'cabinet configurator - choose cabinet collection',
    CHOOSE_CABINET: 'cabinet configurator - choose cabinet',
  },
  ACTION: {
    ADD_CABINET: 'ADD_CABINET_EVENT',
    ADD_ITEM_TO_WALL: 'ADD_ITEM_TO_WALL_EVENT',
    CABINET_COLLECTION_VIEW_DETAILS: 'CABINET_COLLECTION_VIEW_DETAILS_EVENT',
    COLLECTION_REFINEMENTS_FILTERS: 'COLLECTION_REFINEMENTS_FILTERS_EVENT',
    CABINET_COLLECTION_SELECTION: 'CABINET_COLLECTION_SELECTION_EVENT',
    DUPLICATE_CABINET: 'DUPLICATE_CABINET_EVENT'
  }
};

export const ANALYTICS_PROCESS_PRE_IGNITION_EVENTS_DELAY = 5000; // delay sending analytics events
